import { Input } from "@components/ui/input"
import { cn } from "@utils/index"
import * as React from "react"

interface UrlInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  showValue?: boolean
}

export const UrlInput = React.forwardRef<HTMLInputElement, UrlInputProps>(({
  className,
  showValue = false,
  ...props
}, ref) => {
  const [visibleUrl, setVisibleUrl] = React.useState("")

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newUrl = e.target.value

    // Remove https:// or http:// if pasted
    newUrl = newUrl.replace(/^(https?:\/\/)/, "")

    setVisibleUrl(newUrl)
    const fullNewUrl = `https://${newUrl}`
    props.onChange?.({ ...e, target: { ...e.target, value: fullNewUrl } });
  }

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-muted-foreground">
        https://
      </div>
      {
        showValue ?
          <Input
            value=""
            onChange={handleInputChange}
            className={cn("pl-[4.5rem] pr-4", className)}
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck="false"
          />
          : <Input
            {...props}
            ref={ref}
            type="text"
            value={visibleUrl}
            onChange={handleInputChange}
            className={cn("pl-[4.5rem] pr-4", className)}
            placeholder="example.com"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck="false"
          />
      }
    </div>
  )
})
